import { create } from 'zustand';

export type ThemeId = 'dark' | 'light';

/** Whether a theme uses the dark base palette (drives graph/RDF rendering). */
export function isDarkTheme(theme: ThemeId): boolean {
  return theme === 'dark';
}

/** CSS class(es) applied to a themed root element. */
export function themeClass(theme: ThemeId): string {
  return theme === 'light' ? 'light-theme' : '';
}

interface AppState {
  theme: ThemeId;
  darkMode: boolean;
  setTheme: (theme: ThemeId) => void;
}

// Trimmed from upstream: the Witboost host decides the theme, and the app-level
// ontology, quest and query state left with the pages that used them.
export const useAppStore = create<AppState>((set) => ({
  theme: 'dark',
  darkMode: true,
  setTheme: (theme) => set({ theme, darkMode: isDarkTheme(theme) }),
}));
